import {
  GET_ACCOUNT_SETTING_DATA,
  SET_ACCOUNT_SETTING_DATA,
} from "./AccountSettingDataTypes";

const initialState = {
  accountSetting: {},
};

const AccountSettingReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ACCOUNT_SETTING_DATA:
      return {
        ...state,
      };
    case SET_ACCOUNT_SETTING_DATA:
      return {
        ...state,
        accountSetting: action.payload.accountSetting,
      };

    default:
      return state;
  }
};

export default AccountSettingReducer;
